import * as React from "react";
import CircularProgress from "../../../../../common/components/shared/circularProgress/circularProgress";
import {Popup} from "../../../../../common/components/shared/popup/popup";
import {Api, apiUrls} from "../../../../../helpers/api";
import i18n from "../../../../../i18n/i18n";
import {PhotosModel} from "../../../../models/photos";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";
import InnerImageZoom from "react-inner-image-zoom";
import Error from "../../../../../common/components/shared/error/error";
import {useEffect} from "react";

interface ViewPhotoPopupProps {
    displayPopup: boolean;
    closePopup: () => void;
    selectedPhoto: PhotosModel | null;
}

export default function ViewPhotoPopup(props: ViewPhotoPopupProps): React.ReactElement {
    const [error, setError] = React.useState(false);
    const [loader, setLoader] = React.useState(true);

    const imageAlt = props.selectedPhoto ? `${i18n.t("transportation.order.photos.imageAlt", {sideType: props.selectedPhoto.sideType})}` : i18n.t("transportation.order.photos.imageAlt");
    const imageTestId = props.selectedPhoto ? `photo-${props.selectedPhoto?.sideType}-${props.selectedPhoto?.direction}` : "image-error";
    const fileName = props.selectedPhoto ? i18n.t(`transportation.order.photos.sideType.${props.selectedPhoto.sideType}`) : "";
    const imageSrc = getPhotoUrl();

    useEffect(() => {
        setError(false);
    }, [props.displayPopup]);

    const content = (
        <div className="content-wrapper">
            {loader && <CircularProgress/>}
            {error && <Error message={i18n.t("transportation.order.photos.imageNotFoundError")}/>}
            {!error && (
                <InnerImageZoom
                    src={imageSrc}
                    zoomScale={3}
                    className="image-wrapper"
                    imgAttributes={{
                        onError: ({currentTarget}) => {
                            setLoader(true);
                            setError(true);
                            currentTarget.onerror = null;
                            currentTarget.className = "error";
                            setLoader(false);
                        },
                        onLoadCapture: () => setLoader(false),
                        onLoadStart: () => setLoader(true),
                        alt: imageAlt
                    }}
                    data-testid={imageTestId}
                    zoomPreload
                />
            )}
        </div>
    );

    return (
        <Popup
            open={props.displayPopup}
            className="view-photo-popup"
            header={fileName}
            content={content}
            cancel={props.closePopup}
            hideCancelButton
            testId="view-photo-popup"
        />
    );

    function getPhotoUrl() {
        if (props.selectedPhoto && props.selectedPhoto.sideType && props.selectedPhoto.id && props.selectedPhoto.deviceId) {
            return `${Api.getUrl(apiUrls.photos.photo)}/${props.selectedPhoto!.deviceId}/${props.selectedPhoto!.id}/${props.selectedPhoto!.sideType}`;
        }
        return "";
    }
}
